<div class="veify-email-container">
  <i class="icon-email"></i>

  <div class="verifyEmail-content">
    <h1 class="title">{{'verifying.your.email' | translate}}</h1>
  </div>

  <div class="footer-action">
    <app-button [blackTextButton]="true" [buttonName]="'label.back.to.home'" (click)="navigateBackToHome()"></app-button>
  </div>
</div>
